import { useQuery } from "@tanstack/react-query";

import keys from "CommissionDistribution/Api/keys";
import { getContractsContractIdCommissionDistribution } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const useCommissionDistributionQuery = (contractId: string) =>
	useQuery({
		queryKey: keys.commissionDistribution(contractId),
		queryFn: processResponse(() =>
			getContractsContractIdCommissionDistribution(contractId),
		),
		enabled: !!contractId,
	});
